import { render, staticRenderFns } from "./WenFang.vue?vue&type=template&id=867ae256&scoped=true"
import script from "./WenFang.vue?vue&type=script&lang=ts"
export * from "./WenFang.vue?vue&type=script&lang=ts"
import style0 from "./WenFang.vue?vue&type=style&index=0&id=867ae256&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867ae256",
  null
  
)

export default component.exports